var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-card',[(_vm.data.operationalCosts)?_c('v-layout',{staticClass:"pa-4",attrs:{"column":""}},[_c('single-operational-form',{attrs:{"data":_vm.data.operationalCosts}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }